import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.esm.js';
import { Skeleton, Slot, Anchor } from '@costar-ui/components';
import React from 'react';

var WebsiteLink = function WebsiteLink(props) {
  var url = props.url,
    onClick = props.onClick,
    testId = props.testId,
    isLoading = props.isLoading,
    _props$target = props.target,
    target = _props$target === void 0 ? '_blank' : _props$target;
  var extractDomain = function extractDomain(url) {
    var urlCleaner = url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
    return urlCleaner;
  };
  var domain = url ? extractDomain(url) : null;
  return isLoading ? /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25",
    className: "csg-tw-skeleton-website-link"
  }) : url && /*#__PURE__*/React.createElement(Slot, {
    className: "csg-tw-website-link"
  }, /*#__PURE__*/React.createElement(Anchor, _extends({
    variant: "primary-md",
    href: url,
    target: target,
    onClick: onClick,
    testId: testId,
    className: "wrap-anywhere"
  }, props), domain));
};

export { WebsiteLink };
//# sourceMappingURL=website-link.esm.js.map
